// Import the functions you need from the SDKs you need

"use client";

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: "AIzaSyA1QWmA_zbV70TIyHUFvKnTCiwEC_OASnk",
    authDomain: "wearthat-40640.firebaseapp.com",
    projectId: "wearthat-40640",
    storageBucket: "wearthat-40640.firebasestorage.app",
    messagingSenderId: "308426226006",
    appId: "1:308426226006:web:64d0feaf33fddc2b1bfef7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let firestore;
if (typeof window != undefined) {
    firestore = getFirestore(app);
}

export { firestore };
